import React, { useState } from 'react';

const NavigationDots = ({ active }) => {
  const [itemVlaue, setItemValue] = useState('');
  const handleItem = (val) => {
    setItemValue(val);
  };

  return (
    <div className="app__navigation fixed right-0 top-[35%]">
      {['home', 'work', 'about', 'skills', 'contact'].map((item, index) => (
        <a
          href={`#${item}`}
          key={item + index}
          value={item}
          className="app__navigation-dot active:bg-rose-200"
          onClick={(e) => handleItem(item)}
          style={
            item === itemVlaue
              ? { backgroundColor: 'var(--secondary-color)' }
              : {}
          }
        />
      ))}
    </div>
  );
};

export default NavigationDots;
